import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import service from "../src/assets/interest.jpg"
import "./Menu1.css";

const LoansCard = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const loans = [
    "Jewel Loan",
    "Gold Loan",
    "Vehicle Loan",
    "Mortgage Loan",
    "Builders Loan",
    "Housing Loan",
    "Partially Secured Loan",
    "Fully Secured Loan",
    "Over Draft Loan",
  ];

  // Responsive styles
  const containerStyle = {
    maxWidth: isMobile ? "95%" : "500px",
    margin: isMobile ? "10px auto" : "20px auto",
    padding: isMobile ? "15px" : "20px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#fff",
  };

  const headerStyle = {
    textAlign: "center",
    background: "linear-gradient(90deg, #fff, #cb71ca)",
    color: "#700d69",
    padding: isMobile ? "8px" : "10px",
    borderRadius: "8px 8px 0 0",
    fontSize: isMobile ? "18px" : "20px",
    margin: isMobile ? "0 0 10px 0" : "0 0 15px 0",
  };

  const listStyle = {
    listStyleType: "none", 
    padding: 0, 
    margin: 0
  };

  const listItemStyle = (index) => ({
    padding: isMobile ? "8px" : "10px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    fontSize: isMobile ? "14px" : "16px",
    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
  });

  const bannerImageStyle = {
    width: "100%",
    height: isMobile ? "180px" : "340px",
    objectFit: "cover",
  };

  return (
    <div style={{ background: "linear-gradient(90deg, #fff, #cb71ca)" }}>
      <Navbar/>
      
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`} style={{gap: isMobile ? "0px" : "5px"}}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img src={service} alt="About Us" style={bannerImageStyle} />
          </div>
        </div>
      </div>

      <div style={containerStyle}>
        <h2 style={headerStyle}>
          Loans
        </h2>
        <ul style={listStyle}>
          {loans.map((loan, index) => (
            <li
              key={index}
              style={listItemStyle(index)}
            >
              <span>{loan}</span>
            </li>
          ))}
        </ul>
      </div>
      <Footer/>
    </div>
  );
};

export default LoansCard;